// extracted by mini-css-extract-plugin
module.exports = {"inputSearchContainer":"input-search_inputSearchContainer__ABOS_","search-icon":"input-search_search-icon__vGDZl"};